import gql from 'graphql-tag';

export default gql`
    mutation UploadImageToJob($input: UploadImageToJobInput) {
        uploadImageToJob(input: $input) {
            errors
        }
    }
`;
